/**
 * @generated SignedSource<<38f177e54b91e2554e5a9d6510c5be93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BasisEnum = "CASH" | "NORMALIZED" | "%future added value";
export type categorizationOverviewPage_Query$variables = {
  basis?: BasisEnum | null | undefined;
  perspectiveId?: string | null | undefined;
  year?: number | null | undefined;
};
export type categorizationOverviewPage_Query$data = {
  readonly categories: ReadonlyArray<{
    readonly color: string;
    readonly id: string;
    readonly name: string;
    readonly parent: {
      readonly id: string;
    } | null | undefined;
  }>;
  readonly perspective: {
    readonly id: string;
  };
  readonly perspectiveCostTree: ReadonlyArray<{
    readonly category: {
      readonly color: string;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly color: string | null | undefined;
    readonly depth: number;
    readonly kind: string;
    readonly name: string;
    readonly nodeId: string;
    readonly parentNodeId: string | null | undefined;
    readonly points: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly sliceAmountCents: number | null | undefined;
    readonly sliceType: string | null | undefined;
    readonly sliceWeight: number | null | undefined;
    readonly stakeholder: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly yearTotal: number;
  }>;
};
export type categorizationOverviewPage_Query = {
  response: categorizationOverviewPage_Query$data;
  variables: categorizationOverviewPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "basis"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "year"
},
v3 = {
  "kind": "Variable",
  "name": "perspectiveId",
  "variableName": "perspectiveId"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": (v4/*: any*/),
  "concreteType": "Perspective",
  "kind": "LinkedField",
  "name": "perspective",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": (v4/*: any*/),
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "categories",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "basis",
    "variableName": "basis"
  },
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "year",
    "variableName": "year"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentNodeId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "depth",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sliceType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sliceAmountCents",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sliceWeight",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yearTotal",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "categorizationOverviewPage_Query",
    "selections": [
      (v7/*: any*/),
      (v10/*: any*/),
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "CostTreeNode",
        "kind": "LinkedField",
        "name": "perspectiveCostTree",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "points",
            "plural": true,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "categorizationOverviewPage_Query",
    "selections": [
      (v7/*: any*/),
      (v10/*: any*/),
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "CostTreeNode",
        "kind": "LinkedField",
        "name": "perspectiveCostTree",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "points",
            "plural": true,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd53bc94d141d545ed33e8d9fc23ba8c",
    "id": null,
    "metadata": {},
    "name": "categorizationOverviewPage_Query",
    "operationKind": "query",
    "text": "query categorizationOverviewPage_Query(\n  $perspectiveId: ID\n  $year: Int\n  $basis: BasisEnum\n) {\n  perspective(perspectiveId: $perspectiveId) {\n    id\n  }\n  categories(perspectiveId: $perspectiveId) {\n    id\n    name\n    color\n    parent {\n      id\n    }\n  }\n  perspectiveCostTree(perspectiveId: $perspectiveId, year: $year, basis: $basis) {\n    nodeId\n    parentNodeId\n    kind\n    name\n    color\n    depth\n    sliceType\n    sliceAmountCents\n    sliceWeight\n    category {\n      id\n      name\n      color\n    }\n    stakeholder {\n      id\n      name\n    }\n    yearTotal\n    points {\n      month\n      value\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6f075b709dcca48ad18ecbf58cad586";

export default node;
